import api from './api';

export default async function deleteKeyword(id) {
    const { data } = await api.delete(`misspelling-keyword/${id}`);

    return data;
}